import {
  computed,
  reactive,
} from '@vue/composition-api';
import { useZipperApi } from './useZipperApi';

export const useClientsContacted = () => {
  const { client } = useZipperApi();

  const state = reactive({
    /**
       * @type {any[]}
       */
    clientsContacted: [],
    loading: true,
    error: {
      load: null,
    },
  });

  /**
     * @param {string} customerId
     * @param {import("@sejazipper/layer-api-client").CampaignFilters} filters
     */
  const load = async (customerId, filters) => {
    try {
      state.loading = true;
      state.clientsContacted = await client.chain.query
        .clientsContactedByCustomerIdByStoreIds({ customerId, filters })
        .get({ date: true, total: true });
    } catch (e) {
      state.error.load = e;
    } finally {
      state.loading = false;
    }
  };

  return {
    load,
    clientsContacted: computed(() => state.clientsContacted),
    loading: computed(() => state.loading),
    error: computed(() => state.error),
  };
};
